///////////////////////////////////////////////////////////////////////////////////
//
// בהמתנה - the data of the header's hourglass box (HeaderAwaitingBox.vue): the הזמנות
// waiting for the customer's signature, the online booking requests waiting for
// approval, the customers who got the booking link and have not booked yet and the
// contacts sent the contact form who have not filled it (בקשת מילוי פרטי לקוח)
// (GET awaiting, apiv2/src/modules/awaiting/awaiting.service.ts).
//
// The box is mounted twice (the desktop icon row and the mobile one), so the data
// lives here, once: one request at a time, a poll every 5 minutes while a box is
// mounted, a read again after a navigation / a notification / the tab coming back
// when the last read is older than a minute, and a fresh one when a box is opened.
// The plain client (no apiRequest): a poll shows no spinner and no error popup -
// a failed read keeps the last data.
//
///////////////////////////////////////////////////////////////////////////////////

import Vue from 'vue';
import axiosV2 from '../core/http/axios_api_v2';


const POLL_MS = 5 * 60 * 1000;
const STALE_MS = 60 * 1000;


export const awaitingState = Vue.observable({
    data: null,          // { count, orders: {count, rows} | null, booking: {...} | null }
    loading: false,
});


let inFlight = null;
let loadedAt = 0;
let pollTimer = null;
let mountedBoxes = 0;
let unsubscribeStore = null;


function onVisibility() {
    if (document.visibilityState == 'visible')
        loadIfStale();
}


export function loadAwaiting(fresh) {

    if (inFlight)
        return inFlight;

    awaitingState.loading = true;

    inFlight = axiosV2.get('awaiting' + (fresh ? '?fresh=1' : ''))
        .then(response => {
            if (response && response.data && typeof response.data == 'object')
                awaitingState.data = response.data;
            loadedAt = Date.now();
        })
        .catch(() => { /* keep the last data */ })
        .then(() => {
            awaitingState.loading = false;
            inFlight = null;
        });

    return inFlight;
}


export function loadIfStale(maxAgeMs) {
    if (Date.now() - loadedAt > (maxAgeMs || STALE_MS))
        return loadAwaiting();
    return Promise.resolve();
}


// a box was mounted: read now (unless just read) and keep reading while any box is on screen
export function attachAwaiting(store) {

    mountedBoxes++;

    if (mountedBoxes == 1) {

        pollTimer = setInterval(() => {
            //a hidden tab waits for its turn to be seen (visibilitychange)
            if (document.visibilityState != 'hidden')
                loadAwaiting();
        }, POLL_MS);

        document.addEventListener('visibilitychange', onVisibility);

        //a document signed, a booking request arrived... - they come with a notification
        if (store && store.subscribe)
            unsubscribeStore = store.subscribe(mutation => {
                if (mutation.type == 'pushNotification')
                    loadIfStale(10 * 1000);
            });
    }

    loadIfStale(30 * 1000);
}


export function detachAwaiting() {

    mountedBoxes = Math.max(0, mountedBoxes - 1);

    if (mountedBoxes == 0) {

        clearInterval(pollTimer);
        pollTimer = null;

        document.removeEventListener('visibilitychange', onVisibility);

        if (unsubscribeStore) {
            unsubscribeStore();
            unsubscribeStore = null;
        }
    }
}
